import React from 'react';
import DocEditor from '../../elements/editors/DocEditor';
import { RESOURCE_TYPE_FLOW } from 'js/constants/resourceTypes';
import { isFlowNodeResource } from 'js/lib/ResourceUtils';
import FlowOverviewMetrics from 'new/elements/FlowDailyMetrics/FlowOverviewMetrics';

const resolveFlowNodeId = (data) => {
  return (
    data?.flow_node_id ?? data?.origin_node_id ?? (isFlowNodeResource(data) ? data?.id : undefined)
  );
};

class DataFlowOverviewTab extends React.Component {
  componentDidMount() {
    const { data, fetchPipelineDoc } = this.props;

    const flowNodeId = resolveFlowNodeId(data);

    /**
     * @Why?
     * Only fetch the document if we have a resolvable flow node ID.
     * This is to avoid making unnecessary API calls when the data does not contain a valid flow node ID.
     */
    if (flowNodeId) {
      fetchPipelineDoc(flowNodeId);
    }
  }

  render() {
    const { data, doc, isLoading } = this.props;

    return (
      <div className="tab-content doc-tab-fill">
        <DocEditor
          data={data}
          doc={doc}
          isLoading={isLoading.doc}
          updateDoc={this._handleSaveDocContent}
          resourceType={RESOURCE_TYPE_FLOW}
          useGenAi
          standalone
        />
        <FlowOverviewMetrics flow={data} />
      </div>
    );
  }

  /**
   * @Why?
   * DocEditor passes `data.id`, but for non-linked flows `data` is a merge of the flow
   * node and its source/dataset/sink (see getResourceEntity), so `id` is the underlying
   * resource id — not the flow node id that /flows/:id/docs needs. Resolve it from
   * `data` instead, the same way componentDidMount does for the fetch.
   */
  _handleSaveDocContent = (_id, docContent) => {
    const { data, updatePipelineDoc } = this.props;

    const flowNodeId = resolveFlowNodeId(data);

    if (flowNodeId) {
      updatePipelineDoc(flowNodeId, docContent);
    }
  };
}

DataFlowOverviewTab.resolveFlowNodeId = resolveFlowNodeId;

export default DataFlowOverviewTab;
